import { render, staticRenderFns } from "./IconCurrencyBangladeshiOutline.vue?vue&type=template&id=fa28b8c6"
import script from "./IconCurrencyBangladeshiOutline.vue?vue&type=script&lang=js"
export * from "./IconCurrencyBangladeshiOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports